import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styleUrls: ['./checkbox-list.component.scss'],
  standalone: false
})
export class CheckboxListComponent {

  @Input()
  public name: string;

  @Input()
  public values: string[];

  @Input()
  public group: FormGroup = new FormGroup({});

  @Input()
  public display: (value: string) => string = (value) => value;

  public getControl(value: string) {
    return this.group.get(value);
  }
}
